export const MEDIA_QUERY_MD = '@media screen and (max-width: 768px)'
export const MEDIA_QUERY_LG = '@media screen and (min-width: 1024px)'
